import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { iconX } from '@sorare/core/src/atoms/icons/system/iconX.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

const Root = styled(Horizontal)`
  padding: var(--intermediate-unit);
  border-radius: var(--double-unit);
  background-color: var(--c-nd-50);
`;

export const FirstTime = () => {
  const { lifecycle, update } = useLifecycle();
  const { sport } = useSportContext();
  const sawFirstTimeStatsManager =
    lifecycle?.[LIFECYCLE.sawFirstTimeStatsManager];
  const onDismiss = () => {
    update(LIFECYCLE.sawFirstTimeStatsManager, {
      ...sawFirstTimeStatsManager,
      [sport]: true,
    });
  };

  const hasSeen = sawFirstTimeStatsManager?.[sport];

  if (hasSeen) {
    return null;
  }

  return (
    <Root>
      <BodyM>
        <FormattedMessage defaultMessage="Find the right player for your needs by toggling the stats you want to compare!" />
      </BodyM>
      <IconButton
        color="transparent"
        size="small"
        icon={iconX}
        onClick={onDismiss}
      />
    </Root>
  );
};
